import * as React from "react";
import { css } from "@emotion/react";
import {
  fontSize,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { textColor } from "main/javascripts/styles/base/colorStyle";
import { nl2br } from "main/javascripts/utils/StringUtil";

export interface IProps {
  introduction: string;
}

export const LpCruiseIntroduction: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { introduction } = props;

  return (
    <div css={blockStyle}>
      <div css={introductionStyle}>{nl2br(introduction)}</div>
    </div>
  );
};

const blockStyle = css``;
const introductionStyle = css`
  font-size: ${fontSize.body};
  line-height: ${lineHeight.body1};
  color: ${textColor.primaryDarkColor};
`;
